var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapComponent',{staticClass:"residential-map",attrs:{"value":_vm.$path('project.address', _vm.item)}})
}
var staticRenderFns = []

export { render, staticRenderFns }